import { createContext, useContext, useState, useCallback } from 'react';

const NavContext = createContext(null);

export const NavProvider = ({ children }) => {
  // Desktop: icon-only vs full sidebar
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  // Mobile: sidebar visible as overlay
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  // Hover-to-expand: enabled by default for all pages
  const [hoverExpandEnabled, setHoverExpandEnabled] = useState(true);
  const [sidebarHoverExpanded, setSidebarHoverExpanded] = useState(false);

  const toggleSidebar = useCallback(() => setSidebarCollapsed((v) => !v), []);
  const collapseSidebar = useCallback(() => setSidebarCollapsed(true), []);
  const expandSidebar = useCallback(() => setSidebarCollapsed(false), []);
  const toggleMobileSidebar = useCallback(() => setMobileSidebarOpen((v) => !v), []);
  const closeMobileSidebar = useCallback(() => setMobileSidebarOpen(false), []);

  return (
    <NavContext.Provider
      value={{
        sidebarCollapsed,
        mobileSidebarOpen,
        hoverExpandEnabled,
        setHoverExpandEnabled,
        sidebarHoverExpanded,
        setSidebarHoverExpanded,
        toggleSidebar,
        collapseSidebar,
        expandSidebar,
        toggleMobileSidebar,
        closeMobileSidebar,
      }}
    >
      {children}
    </NavContext.Provider>
  );
};

export const useNav = () => {
  const ctx = useContext(NavContext);
  if (!ctx) throw new Error('useNav must be used within NavProvider');
  return ctx;
};
